import { pxToRem } from '../../../../utils';
var formStyles = {
  root: function root(_ref) {
    var props = _ref.props,
        variables = _ref.variables;
    return {
      height: '100%',
      width: '100%',
      display: 'grid',
      gridTemplateColumns: '1fr',
      justifyContent: 'space-evenly',
      gridGap: pxToRem(20),
      justifyItems: 'start'
    };
  }
};
export default formStyles;